import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CONTACT_EMAIL, CONTACT_PHONE, telHref } from '../config/site';

const linkClass =
  'text-white/65 hover:text-white transition-colors focus-visible:outline-none focus-visible:text-white focus-visible:underline';

export const Footer = () => {
  const { user } = useAuth();
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-ink text-white py-16 px-4 sm:px-6">
      <div className="absolute inset-x-0 top-0 h-[3px] bg-logo-gradient" aria-hidden="true" />
      <div className="max-w-7xl mx-auto">
        <div className="grid gap-10 sm:grid-cols-2 md:grid-cols-4">
          <div className="sm:col-span-2 md:col-span-2">
            <Link to="/" className="inline-block mb-4 rounded-2xl bg-paper px-4 py-3" aria-label="Azamein home">
              <img src="/azamein-logo.png" alt="Azamein" className="h-8 w-auto" width="254" height="72" />
            </Link>
            <p className="text-white/65 text-sm leading-relaxed max-w-xs">
              Beautiful, professional invitations for weddings, bar and bat mitzvahs, and every
              meaningful family simcha.
            </p>
            <p className="text-white/40 text-xs mt-3">Azamein is a brand name under Herlich Design</p>
          </div>

          <nav aria-label="Explore">
            <h2 className="font-serif text-lg mb-4 text-white">Explore</h2>
            <ul className="flex flex-col gap-3 text-sm">
              <li>
                <Link to="/templates" className={linkClass}>Browse templates</Link>
              </li>
              {user ? (
                <>
                  <li>
                    <Link to="/dashboard" className={linkClass}>My invitations</Link>
                  </li>
                  <li>
                    <Link to="/cart" className={linkClass}>Cart</Link>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <Link to="/login" className={linkClass}>Sign in</Link>
                  </li>
                  <li>
                    <Link to="/register" className={linkClass}>Create an account</Link>
                  </li>
                </>
              )}
            </ul>
          </nav>

          <nav aria-label="Help and legal">
            <h2 className="font-serif text-lg mb-4 text-white">Help</h2>
            <ul className="flex flex-col gap-3 text-sm">
              <li>
                <Link to="/sms-getting-started" className={linkClass}>SMS updates</Link>
              </li>
              <li>
                <Link to="/partner" className={linkClass}>For invitation designers</Link>
              </li>
              <li>
                <Link to="/terms" className={linkClass}>Terms &amp; Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy" className={linkClass}>Privacy Policy</Link>
              </li>
              {CONTACT_PHONE && (
                <li>
                  <a href={telHref(CONTACT_PHONE)} className={linkClass}>Call to order: {CONTACT_PHONE}</a>
                </li>
              )}
              {CONTACT_EMAIL && (
                <li>
                  <a href={`mailto:${CONTACT_EMAIL}`} className={linkClass}>{CONTACT_EMAIL}</a>
                </li>
              )}
            </ul>
          </nav>
        </div>

        <div className="border-t border-white/10 mt-10 pt-8 text-white/40 text-sm flex flex-col items-center gap-2 text-center md:flex-row md:justify-between md:text-start">
          <p>© {year} Azamein. All rights reserved.</p>
          <p className="text-xs" dir="ltr">
            Built by{' '}
            <a
              href="https://devniks.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/55 hover:text-white transition-colors focus-visible:outline-none focus-visible:text-white focus-visible:underline"
            >
              Devniks.com<span className="sr-only"> (opens in a new tab)</span>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
